import { render, staticRenderFns } from "./UrlConsulta.vue?vue&type=template&id=22d4e9a8&scoped=true&"
import script from "./UrlConsulta.vue?vue&type=script&lang=js&"
export * from "./UrlConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4e9a8",
  null
  
)

export default component.exports